import React, { useState, useEffect, Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { setAlert } from '../../../actions/alert';
import { crearInstitucionConfiguracion } from '../../../actions/configuracion';

const NuevaInstitucion = ({ institucion, reestablecerInstitucion }) => {

    const dispatch =  useDispatch();

    const [nuevoModal, setNuevoModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [institucionData, setInstitucionData] = useState({
        id: null, 
        nombre: null
    });

    /* Crear institucion */
    const handleInputChange = ({ target }) => {
        setInstitucionData({
            ...institucionData,
            [target.name]: target.value
        });
    }
    
    const handleProcesar = async () => {
        if(institucionData.nombre && institucionData.id){
            await setStatusProcesar(true);
            await dispatch(crearInstitucionConfiguracion(institucionData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Completa todos los campos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setInstitucionData({
                id: null, 
                nombre: null
            });

            setNuevoModal(false);

            reestablecerInstitucion(null);
        }
    }

    useEffect(() => {
        if(institucion){
            setNuevoModal(true);

            setInstitucionData({
                ...institucionData,
                id: institucion.id
            });
        }        
    }, [institucion]);

    return (
        <Fragment>
            <Modal show={nuevoModal} size="md" backdrop="static" centered onHide={() => handleCerrar()}>
                <Modal.Header closeButton>
                    <Modal.Title>Agregar Institución</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="form-group mb-3 col-md-12">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={institucionData.nombre} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>
                    </div>                    
                </Modal.Body>
                <Modal.Footer>
                    {
                        statusProcesar ?
                            <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Agregar</button>
                        :
                            <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Agregar</button>
                    }
                </Modal.Footer>
            </Modal>
        </Fragment>
    )
}

export default NuevaInstitucion;